import { onToggle } from '../utils/class-list'
import { onSelect } from '../utils/dom'

class DropDown {
  constructor(options = {}) {
    let className = { ...options.class }
    let objClass = Object.entries(className).length === 0 ? { toggle: 'closed' } : className

    this.source = onSelect(options.source) || null
    this.sourceSelector = options.source || ''
    this.target = onSelect(options.target) || null
    this.targetSelector = options.target || ''
    this.class = objClass
    this.changeText = options.changeText || false
    this.textSelector = options.textSelector || null
    this.textOpen = options.textOpen || 'open'
    this.textClose = options.textClose || 'close'

    if (this.onInit()) return

    this.onHandlerClick(this.source, this.class.toggle)
  }

  onInit() {
    if (this.source === null && this.target === null) {
      console.error(`ERROR: Error in the initialization of the dropdown`)
      return true
    }
  }

  onHandlerClick(nodeListen, classHanlder) {
    if (nodeListen === null || nodeListen === '') return

    nodeListen.addEventListener('click', (event) => {
      event.preventDefault()
      onToggle(this.target, `${classHanlder}`)

      if (this.changeText) this.onChangeText(classHanlder)
    })
  }

  onChangeText(classHanlder) {
    if (this.target.classList.contains(classHanlder)) {
      this.onUpdatedText(this.source, this.textSelector, this.textClose)
    } else {
      this.onUpdatedText(this.source, this.textSelector, this.textOpen)
    }
  }

  onUpdatedText(textTarget, textTargetAlternative, textChange) {
    if (textTargetAlternative === null) {
      textTarget.innerText = textChange
    } else {
      let alternativeTarget = onSelect(textTargetAlternative, textTarget)
      if (alternativeTarget === null) return

      alternativeTarget.innerText = textChange
    }
  }
}

if (onSelect('#box-primary-nav')) {
  const openPrimaryNav = new DropDown({
    source: 'a[href="#nav-primary"]',
    target: '#box-primary-nav',
    changeText: false,
  })

  const closePrimaryNav = new DropDown({
    source: '#close-primary-nav',
    target: '#box-primary-nav',
    changeText: false,
  })
}
